import { render } from "./ProjectDataListNoneItem.vue?vue&type=template&id=fa8fc984"
import script from "./ProjectDataListNoneItem.vue?vue&type=script&lang=js"
export * from "./ProjectDataListNoneItem.vue?vue&type=script&lang=js"

import "./ProjectDataListNoneItem.vue?vue&type=style&index=0&id=fa8fc984&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__